import React from 'react';
import {useScoringRun} from '../../../context/ScoringRunContext';
import {useTags} from '../../../hooks/api/tags';
import {useAccountView, useIsMyAccountsView} from '../AccountViewContext';
import {useIsFeatureEnabled} from '../../../hooks/api/metadata';
import {AccountFilterCondition} from '../../../shared/filter/accountFilter';

export const useFilterOptions = (): AccountFilterCondition['field'][] => {
  const accountView = useAccountView();
  const isMyAccountsView = useIsMyAccountsView();
  const scoringRun = useScoringRun();
  const lookalikesWithLogos = scoringRun?.lookalikesWithLogos;
  const tags = useTags({});
  const isIntentEnabled = useIsFeatureEnabled('intent');
  const showIntentFilter =
    isMyAccountsView && isIntentEnabled && !!scoringRun?.intentModels?.length;

  // All available filter fields (we allow multiple of the same type now)
  return React.useMemo(() => {
    return [
      'tier',
      showIntentFilter && 'intentTier',
      !!lookalikesWithLogos?.length && 'similarTo',
      'signals',
      showIntentFilter && 'matchedIntentFields',
      isMyAccountsView && !!tags.data?.length && 'tags',
      'primaryCategory',
      'audience',
      isMyAccountsView && accountView !== 'crm' && 'inCRM',
      isMyAccountsView && 'inSAM',
      'employees',
      'funding',
      'trafficRank',
      'hqCountry',
      'hqState',
    ].filter(Boolean) as AccountFilterCondition['field'][];
  }, [
    accountView,
    isMyAccountsView,
    lookalikesWithLogos,
    tags.data,
    showIntentFilter,
  ]);
};
